import ApiService from '@/utils/ApiService';
import { collectArticleIds } from '@/modules/table-of-contents';

export default {
	state: {
		hasDeletedNodes: false,
		tocNodeIds: new Set(),
	},
	getters: {
		getHasDeletedNodes(state) {
			return state.hasDeletedNodes;
		},
		getTocNodeIds(state) {
			return state.tocNodeIds;
		},
	},
	mutations: {
		SET_HAS_DELETED_NODES(state, status) {
			state.hasDeletedNodes = status;
		},
		SET_TOC_NODE_IDS(state, ids) {
			state.tocNodeIds = ids;
		},
	},
	actions: {
		async checkDeletedNodes({ commit, rootGetters }) {
			const mapsURL = rootGetters['maps/getMapsURL'];
			const mapId = rootGetters['maps/getCurrentMapId'];
			const tocURL = rootGetters['maps/getTOCURL'];

			try {
				const { data } = await ApiService.get(`${mapsURL}${mapId}${tocURL}`);
				const individualOrder = data.content.individual_order || [];
				const tocIds = collectArticleIds(individualOrder);
				commit('SET_TOC_NODE_IDS', tocIds);

				if (tocIds.size === 0) {
					commit('SET_HAS_DELETED_NODES', false);
					return;
				}

				const rawNodes = rootGetters['nodes/getRawNodes'];
				const rawNodeIds = new Set(rawNodes.map((node) => node.id));
				const hasDeleted = [...tocIds].some((id) => !rawNodeIds.has(id));
				commit('SET_HAS_DELETED_NODES', hasDeleted);
			} catch {
				commit('SET_HAS_DELETED_NODES', false);
			}
		},
	},
	namespaced: true,
};
